import React, { Component } from 'react'
import {
  NavBar,
  Icon,
  List,
  WhiteSpace,
  InputItem,
  Button,
  WingBlank,
  TextareaItem,
  Toast,
  Picker,
} from 'antd-mobile'
import { connect } from 'dva'
import './addGroup.scss'
import SelectUser from './selectUser'
import axios from '../../../../service/axios'
import { createForm } from 'rc-form'
import userList from '../../../../models/userList'
let Item = List.Item
const selectedContainer = {
  position: 'fixed',
  width: '100%',
  top: '0',
  background: '#f5f5f5',
  height: '100%',
  zIndex: '11',
  transition: 'left 0.4s',
}
export class AddGroup extends Component {
  state = {
    groupErr: '',
    drawerLeft: document.body.clientWidth,
    name: '',
    owner: '',
    adminList:[{key: '',id: ''}],
    userList: {resultList: [],totalCount:0,pageNo:1},
  }
  componentDidMount() {
    if (this.props.match.params.type == 'edit') {
      // 查询可加入的用户
      this.getGroupUserList()
      this.setState({
        name: this.props.match.params.name,
        owner: this.props.match.params.owner,
      })
    } else {
      //查询企业管理员
      this.getEnterproseAdminList()
      this.props.setSelectUserList([])
    }
  }
  onAddGroup() {
    this.props.form.validateFields({ force: true }, (error) => {
      console.log(this.props.form.getFieldsValue())
      if (!error) {
        this.addGroup(this.props.form.getFieldsValue())
      }
    })
  }
  // 群组信息提交 (创建/修改)
  addGroup(data) {
    let type = this.props.match.params.type == 'edit' ? 'update' : 'create'
    console.log('类型:',type)
    console.log('参数~:',data)
    console.log('参数(用户)~:',this.props.selectUserListUidArr)
    console.log('参数owner(修改)~:',this.state.owner)
    // console.log('参数owner(添加)~:',data.admin Info[0])

    axios
      .post('/api/enterprise/group/' + type, {
        ...data,
        users: this.props.selectUserListUidArr,
        gid: this.props.match.params.gid,
        owner: type == 'update' ? this.state.owner : data.adminInfo[0],
      })
      .then((res) => {
        if (res) {
          if (res.status == 200) {
            Toast.success(res.message, 1, () => {
              this.props.setEmpty()
              this.props.history.replace('/enterprise/group/enterpriseGroupList')
            })
          } else {
            Toast.fail(res.message)
          }
        }
      })
      .catch((res) => {
        Toast.hide()
      })
  }
  getGroupUserList() {
    axios
      .get('/api/group/members', {
        params: {
          gid: this.props.match.params.gid,
          pageNo: 1,
          pageSize: 3000,
          owner: this.props.match.params.owner,
        },
      })
      .then((res) => {
        if (res && res.status == 200 && res.data) {
          this.props.setSelectUserList(res.data.resultList || [])
        }
      })
  }
  getEnterproseAdminList(){
    axios.post('/api/enterprise/admin/page', {
      page: {
        pageNo:1,
        pageSize: 2000
      }
    }).then(res => {
      console.log('查询的管理:',res)
      if(res&&res.status == 200){
        let pickerData = []
        res.data.map(item => {
          pickerData.push({
            label: item.loginName,
            value: item.id
          })
        })
        this.setState({
          adminList: pickerData
        })
      }
    },() => {
      console.log('查询结果?',this.state)
    })
  }
  validaetName = (rule, value, callback) => {
    if (value) {
      if (value.trim()) {
        if (/^[a-zA-Z0-9_\u4e00-\u9fa5]{1,11}$/.test(value)) {
          callback()
        } else {
          callback(new Error('名称只支持1~11位中文数字字母和下划线'))
        }
      } else {
        callback(new Error('请填写群组名'))
      }
    } else {
      callback(new Error('请填写群组名'))
    }
  }
  
  render() {
    const { selectUserList } = this.props
    const { groupErr, drawerLeft,adminList,userList } = this.state
    const { getFieldProps, getFieldError } = this.props.form
    const { name } = this.state
    const remarks = sessionStorage.getItem('groupRemarks')
    const userMsg =
      sessionStorage.getItem('loginMsg') &&
      JSON.parse(sessionStorage.getItem('loginMsg'))
    const handelAdminInfoGet = (res) => {
      console.log('选择了管理员?',res)
      //查询这个管理员下有哪些成员
      axios.get('/api/group/no_members', {
        params: {
          owner: res[0],
          pageNo:1,
          pageSize:50
        }
      }).then(res => {
        if(res&&res.status == 200) {
          this.setState({
            userList : res.data
          })
        }
      })
    }
    const selectUserProps = {
      ...this.props.match.params,
      userList
    }
    return (
      <div className='addgroup'>
        <div className='header-sticky'>
          <NavBar
            icon={<Icon type='left' />}
            onLeftClick={() => this.props.history.goBack()}
          >
            {this.props.match.params.type == 'edit' ? name +' 详情': '群组添加'}
          </NavBar>
        </div>
        <div className='sub-container'>
          <List renderFooter={() => getFieldError('name') || groupErr}>
            <InputItem
              {...getFieldProps('name', {
                rules: [
                  {
                    validator: this.validaetName,
                  },
                ],
                initialValue: name,
              })}
              clear
              ref={(el) => (this.autoFocusInst = el)}
              maxLength='11'
              placeholder='请填写群组名'
            >
              群组名字
            </InputItem>
            {this.props.match.params.type == 'edit' ? '':(
              <Picker 
                data={adminList} 
                cols={1} 
                {...getFieldProps('adminInfo')} 
                className="forss"
                onOk={handelAdminInfoGet}
              >
                <List.Item arrow="horizontal">选择企业管理员</List.Item>
              </Picker>
            )}
            <Item
              ref={(el) => (this.autoFocusInst = el)}
              arrow='horizontal'
              onClick={() =>
                this.setState({
                  drawerLeft: 0,
                })
              }
              extra={
                selectUserList.length > 0
                  ? `已选${selectUserList.length}个成员`
                  : '请选择组员'
              }
            >
              群组成员
            </Item>
            <TextareaItem
              {...getFieldProps('remarks', {
                initialValue: remarks,
              })}
              title='备注'
              placeholder=''
              data-seed='logId'
              ref={(el) => (this.autoFocusInst = el)}
              autoHeight
            />
          </List>
          <WhiteSpace size='xl' />
          <WingBlank>
            {this.props.match.params.type == 'edit' ? (
              <div>
                <Button type='primary' onClick={() => this.onAddGroup()}>
                  修改
                </Button>
                <WhiteSpace size='xl' />
                {/* <Button
                  type="primary"
                  onClick={() =>
                    this.props.history.push(
                      `/groupuserlist/${this.props.match.params.gid}/${name}`,
                    )
                  }
                >
                  成员优先级
                </Button>
                <WhiteSpace size="xl" /> */}
              </div>
            ) : (
              <Button type='primary' onClick={() => this.onAddGroup()}>
                确定
              </Button>
            )}
          </WingBlank>
          <WhiteSpace size='xl' />
          <WingBlank>
            <Button onClick={() => this.props.history.goBack()}>返回</Button>
          </WingBlank>
          <WhiteSpace size='xl' />
        </div>
        <div
          style={{
            ...selectedContainer,
            left: drawerLeft + 'px',
          }}
        >
          <SelectUser
            closeDrawer={() => {
              this.setState({
                drawerLeft: document.body.clientWidth,
              })
            }}
            {  ...selectUserProps }
          />
        </div>
      </div>
    )
  }
}
const mapStateToProps = (state) => {
  return {
    selectUserList: state.enterprisegroup.selectUserList,
    selectUserListUidArr: state.enterprisegroup.selectUserListUidArr,
  }
}
const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    setSelectUserList: (data) => {
      dispatch({
        type: 'enterprisegroup/setSelectUserList',
        data,
      })
    },
    setEmpty: (data) => {
      dispatch({
        type: 'enterprisegroup/deleteSelectUserList',
      })
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(createForm()(AddGroup))
